export default Object.freeze({
  OUT_OF_PLAYER_CARDS: 'You have run out of player cards.',
  OUT_OF_CUBES: (color) => `You have run out of ${color} disease cubes.`,
  OUTBREAKS: 'Eight outbreaks have occurred.'
});



/** WEBPACK FOOTER **
 ** ./src/constants/defeatMessages.js
 **/